export const isDateInvalid = (value: any): boolean => {
  return (
    value === null ||
    value === undefined ||
    value === "" ||
    value.toLowerCase?.() === "invalid date"
  );
};

export const getValueOrDefault = (value: any, defaultValue = "- - -") => {
  if (isDateInvalid(value)) {
    return defaultValue;
  }
  return value ?? defaultValue;
};
